
/*   =================================================== */

function commonscripts() {

    /* LP Page => JE DEMANDE MA VOYANCE GRATUITE Button click to scroll (start)*/
    jQuery(".scrolltoform").click(function () {
        var formposition = jQuery('.whitebox_content').offset().top;
        jQuery("html, body").animate({scrollTop: formposition}, 1000);
    });

    jQuery(".backtotop").click(function () {
        jQuery("html, body").animate({scrollTop: 0}, 1000);
    });
    /* LP Page => JE DEMANDE MA VOYANCE GRATUITE Button click to scroll (end)*/


    jQuery(".tooltip_info").on("mouseenter mouseleave", function (event) {
        jQuery('.tooltip_main').toggleClass("active_tooltip");
    });


    /* ==== TOGGLE SCRIPT ==== */
    jQuery(document).on('click', function (event) {

        /* ======================  common in all page sidebar script   ========================== */

        jQuery('.page-template-tpl_contact').find(".right-sidebar").parent().css("height", "");

        jQuery('.SideForm').slideUp();

        jQuery('.CartDropDown').slideUp();

        jQuery('.HeaderCart > a').removeClass('cartOpen');

    });
}

function atachdetach() {

    /* ==== ATTACH DETACH SCRIPT ==== */

    if (jQuery(window).width() < 985) {

        var description = jQuery('.TestimonialBlock').detach();

        jQuery('.MobileTestimonialInner').append(description);

        var homedescription = jQuery('.home .FooterGridMobie').detach();

        jQuery('.MobileFooterGridInner').append(homedescription);

    } else if (jQuery(window).width() > 986) {

        var description = jQuery('.TestimonialBlock').detach();

        jQuery('.TestimonialBlockWrap').append(description);

        var homedescription = jQuery('.home .FooterGridMobie').detach();

        jQuery('.FooterGrid.two').append(homedescription);

    }

    if (jQuery(window).width() > 984) {

        var topbannerh = jQuery('.right-sidebar .PageRightBanner').innerHeight();

        var topbannersidebar = jQuery('.right-sidebar .SideForm').height();

        var recentpost = jQuery('.right-sidebar .recentpost').height();

        if (!jQuery('.page').hasClass('page-template-tpl_contact')) {

            jQuery('.right-sidebar .SideForm').height(topbannerh + recentpost + 65);

        } else {

            jQuery(".PageRightBanner").click(function () {

                jQuery('.page-template-tpl_contact').find(".right-sidebar").parent().height(topbannersidebar);

            });

        }

    }

}



function stick_bar(){
    var offsettop = jQuery('.Page').offset().top;
    var footerheight = jQuery('footer').height();
    var offsettopfooter = jQuery('footer').offset().top - jQuery(window).height();
    var windscrolltop = jQuery(document).scrollTop();

    if (jQuery(window).width() < 984) {
        if ((offsettop < windscrolltop) && (offsettopfooter > windscrolltop)) {
            $('.stickyCta').addClass('fixedscroll');
            $('.stickyCta').addClass('is_stuck');
            $('.stickyCta').show();
        } else if (offsettop > windscrolltop) {
            $('.stickyCta').removeClass('is_stuck');
            $('.stickyCta').removeClass('fixedscroll');
            $("body").removeClass("formOpen");
        } else if (offsettopfooter < windscrolltop) {
            $('.stickyCta').hide();
        }
    } else {
        $('.stickyCta').removeClass('is_stuck');
        $('.stickyCta').show();
    }
}



function middleimage() {
    var p = jQuery(window).height();
    var q = jQuery(".maintenanceBox .whitebox_content").innerHeight();
    var r = (p - q) / 2;
    jQuery(".maintenanceBox .whitebox_content").css("margin-top", r);
}


jQuery(document).ready(function () {

    jQuery(".parchemin_one p, .prachemin_two.black p").each(function () {
        var $this = jQuery(this);
        if ($this.html().replace(/\s| /g, '').length === 0)
            $this.remove();
    });

    // jQuery(".parchemin_one").each(function(){
    // 	jQuery(this).find("p:first-child").html(function (i, html){
    // return html.replace(/^[^a-zA-Z]*([a-zA-Z])/g, '<span class="drop-cap">$1</span>');
    // 	});
    // });

    var i = 1;
    jQuery(".parchemin_one").each(function () {
        var $this = jQuery(this);
        $this.addClass("parchemin_one_item-" + (i)).next().addClass("parchemin-one-controls parchemin-one-control-item-" + (i)).attr("data-class", "parchemin_one_item-" + (i));
        i++;
    });
    jQuery(document).on("click", ".parchemin-one-controls li a", function (e) {
        if (jQuery(this).attr("data-flag") != "true") {
            e.preventDefault();
            var c = jQuery(this).parents(".parchemin-one-controls").attr("data-class");
            var $this = jQuery(this);
            jQuery($this).parent().parent().find("a.zoom").fancybox({
                helpers: {
                    overlay: {
                        locked: false
                    }
                }
            });
            html2canvas(jQuery("." + c), {
                letterRendering: true,
                onrendered: function (canvas) {
                    var dataUrl = canvas.toDataURL('image/png', 1.0);
                    jQuery($this).parent().parent().find("a").attr("href", dataUrl).attr("data-flag", "true");
                    jQuery($this).parent().parent().find("a.print").on("click", function(){
                        printJS(dataUrl, 'image');
                        return false;
                    });
                    jQuery($this).delay().trigger('click');
                }

            });
        }
    });

    middleimage();
    atachdetach();
    commonscripts();
    stick_bar();


    if (("ontouchstart" in document.documentElement)) {
        // It's a touch screen device.

    }


    /* =============================== Related product match hight (Start)  =============================== */
    jQuery('.productone .product-description').matchHeight();
    /* =============================== Related product match hight (End)  =============================== */

    /*=================================== Free Angel Reading Page popup (start)  ====================================*/

    /**
     * load pages inside a modal
     * tiggers a modal on every link in the footer-nav & on every tag with the data-open attribute
     */
    $('footer').before('<div class="reveal" id="modal" data-reveal data-multiple-opened="true" data-reset-on-close="true"><button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button></div>');
    $(document).foundation();
    $('#menu-footer-menu li a, [data-open], .popup-trigger').click(function(e) {
        e.preventDefault();
        var $modal = $('#modal');
        $.ajax(this.href).done(function(resp) {
            var body = resp.match(/<body[^>]*>[\s\S]*<\/body>/gi);
            $modal.html(body).foundation('open');
            $modal.append('<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button>');
        });
    });

    /**
     * global function to load a page inside a modal (for lp-chat)
     * add <a href="#" onlick="openPopup('/page_url_to_load/')"></a>
    */
    window.openPopup = function(href) {
        var $modal = $('#modal');
        $.ajax(href).done(function(resp) {
            var body = resp.match(/<body[^>]*>[\s\S]*<\/body>/gi);
            $modal.html(body).foundation('open');
            $modal.append('<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button>');
        });
    }

    //jQuery('a[href="#popup"] ').addClass('popup-trigger');

    /*jQuery(".popup-trigger").live("click",function(){

     jQuery("#popup.reading_terms").addClass("openPopup");

     jQuery("body").addClass("popup-open");

     });

     jQuery(".close-btn").live("click",function(){

     jQuery("#popup.reading_terms").removeClass("openPopup");

     jQuery("body").removeClass("popup-open");

     }); */

    jQuery(document).on('click', '.popup-open .Main', function () {

        jQuery('.close-btn').trigger('click');

    });


    /*=================================== Free Angel Reading Page popup (end)  ====================================*/


    /*jQuery('a[href="#privacy_popup"] ').addClass('popup-trigger_privacy');

     jQuery(".popup-trigger_privacy").live("click",function(){

     jQuery("#privacy_popup.reading_privacy").addClass("openPopup");

     jQuery("body").addClass("popup-open");

     });

     jQuery(".reading_privacy .close-btn").live("click",function(){

     jQuery("#privacy_popup.reading_privacy").removeClass("openPopup");

     jQuery("body").removeClass("popup-open");

     }); */

    jQuery(document).on('click', '.popup-open .Main', function () {

        jQuery('.close-btn').trigger('click');

    });

    jQuery(document).on('click', '.reading_privacy .popmain-container', function (event) {

        event.stopPropagation();

    });


    /* ===========================  bdc page script (start) ============================== */

    jQuery(".firstname, .lastname").keyup(function () {
        if (jQuery(this).find('input').val().length > 0) {
            jQuery(this).addClass('grayesh');
        } else {
            jQuery(this).removeClass('grayesh');
        }
    });

    jQuery('.status').find("option[value='civil_status']").attr('selected', 'selected');

    jQuery('.status').on('change', function () {

        if ((this.value) == 'Civil status') {

            jQuery(this).parent('.FormRow').removeClass('grayesh');

        } else {

            jQuery(this).parent('.FormRow').addClass('grayesh');

        }

    });

    jQuery(".topheading .pull-right").click(function (event) {
        jQuery(this).find('.btn-round').toggleClass("icon-arrow-down icon-arrow-up");
        jQuery(this).find('.btn-round').parents('.topheading').next().slideToggle();

        if (jQuery(this).find('.btn-round').hasClass('icon-arrow-down')) {
            jQuery(this).find('.btn-round').parents('.topheading').find('.textchange').text('editer');
        } else if (jQuery(this).find('.btn-round').hasClass('icon-arrow-up')) {
            jQuery(this).find('.btn-round').parents('.topheading').find('.textchange').text('fermer');
        }
    });

    /* ===========================  bdc page script (End) ============================== */

    /* ====================================== LP PAge Toggle (Start) ======================================= */

    jQuery('.lp_content').each(function () {

    });

    /* ============================= LP PAge Toggle (End) ======================================= */


    jQuery('.noAutoComplete').attr('autocomplete', 'off');

    jQuery('.eshopmain').matchHeight();

    jQuery(".MobileMenuBtn").click(function () {

        if (jQuery(window).width() < 985) {

            jQuery(".HeaderCart > a.cartOpen").removeClass("cartOpen");

            jQuery(".CartDropDown").hide();

            jQuery(".MobileMenuBtn").toggleClass("active");

            jQuery(".HeaderBottom").slideToggle(300, function () {

            });

        }

    });

    /* ============ SLICK SLIDER SCRIPT ============ */

    jQuery('.HomeMainSlider').slick({
        speed: 300,
        autoplay: true,
        autoplaySpeed: 6000,
        infinite: true
    });

    jQuery('.TestimonialSlider').slick({
        speed: 300,
        autoplay: false,
        infinite: true
    });

    jQuery('.LP_TestimonialSlider').slick({

        infinite: true,

        slidesToShow: 3,

        slidesToScroll: 1,

        draggable: false,

        touchMove: true,

        dragging: false,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true

                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                }
            }

            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });


    jQuery('.ShopOnlineSlider').slick({
        speed: 300,
        autoplay: false,
        infinite: true,
        dots: true,
        arrows: false
    });

    jQuery('.HomeBlogSlider').slick({
        speed: 300,
        autoplay: false,
        infinite: true,
        dots: true,
        arrows: false
    });
    jQuery('.img-desktop , .img-responsive, .iphone-img').slick({
        speed: 300,
        autoplay: false,
        infinite: true,
        dots: true,
        arrows: false
    });


    jQuery('.PageWrap').not('.PageRightBanner.WithImg').click(function () {

        jQuery('.SideForm').slideUp();

    });

    jQuery(".PageRightBanner").click(function (event) {
        jQuery("body").toggleClass("formOpen");
        jQuery(".SideForm").slideToggle(400, function () {
        });

        event.stopPropagation();
    });


    jQuery('.SideForm, .CartDropDown').click(function (event) {

        event.stopPropagation();

    });

    jQuery(".SideForCloseBtn").click(function () {
        jQuery('.page-template-tpl_contact').find(".right-sidebar").parent().css("height", "");
        jQuery("body").toggleClass("formOpen");
        jQuery(".SideForm").slideToggle(300, function () {
        });
    });

    if (jQuery(window).width() < 985) {

        jQuery(".CartDropDown").hide();

    }

    jQuery(".HeaderCart > a").bind("click", function (event) {

        if (jQuery(window).width() < 985) {

            jQuery(".MobileMenuBtn.active").toggleClass("active");

            jQuery(".HeaderBottom").hide();

            if (jQuery(this).attr("class") == "cartOpen") {

                jQuery(this).removeClass("cartOpen");

                jQuery(".CartDropDown").slideUp();

            } else {

                jQuery(this).addClass("cartOpen");

                jQuery(".CartDropDown").slideDown();

            }

        }

        event.stopPropagation();

    });





    // ======================= Read more for testimonial  page content (start) ============================


    jQuery('.BLogListItemButton').click(function () {

        if (jQuery(this).parent('.ShareButton').prev('.testimonialblock').find('.trimcontent').is(':visible')) {

            jQuery(this).find('span.signicon').text('-');

            jQuery(this).parent('.ShareButton').prev('.testimonialblock').find('.trimcontent').hide();

            jQuery(this).parent('.ShareButton').prev('.testimonialblock').find('.full-content').show();

            jQuery(this).find('.btn-round').addClass('active');


        } else if (jQuery(this).parent('.ShareButton').prev('.testimonialblock').find('.trimcontent').is(':hidden')) {

            jQuery(this).find('span.signicon').text('+');

            jQuery(this).parent('.ShareButton').prev('.testimonialblock').find('.trimcontent').show();

            jQuery(this).parent('.ShareButton').prev('.testimonialblock').find('.full-content').hide();

            jQuery(this).find('.btn-round').removeClass('active');

        }

    });
    if (jQuery(window).width() >= 1024) {
        jQuery('.PageRightBanner').click(function () {
            jQuery('html, body').animate({scrollTop: jQuery('.SideForm').offset().top}, 'slow');
        });
    }

    $('a[href*="#"]:not([href="#"])').click(function () {

        var target = $(this.hash);

        target = target.length ? target : $('[name=' + this.hash.substr(1) + ']');

        if (target.length) {

            $('html,body').animate({

                scrollTop: target.offset().top

            }, 400);

        }

    });

    //}


    /* ======================= WATERMARK SCRIPT ======================= */

    jQuery('#je_demande .firstname').watermark('Name', {useNative: false});
    jQuery('#je_demande .email').watermark('Email', {useNative: false});

    jQuery('.bdcform  .firstname .watermark').watermark('Firstname', {useNative: false});
    jQuery('.bdcform  .lastname .watermark').watermark('Name', {useNative: false});
    jQuery('.bdcform  .email .watermark').watermark('Email', {useNative: false});
    jQuery('.bdcform  .mobile .watermark').watermark('Mobile number (optional)', {useNative: false});
    jQuery('.bdcform  .address .watermark').watermark('Address1', {useNative: false});
    jQuery('.bdcform  .floor .watermark').watermark('Floor (optional)', {useNative: false});
    jQuery('.bdcform  .apartment .watermark').watermark('Apartment (optional)', {useNative: false});
    jQuery('.bdcform  .zipmain .zip .watermark').watermark('Zip code', {useNative: false});
    jQuery('.bdcform  .zipmain .city .watermark').watermark('Town / City', {useNative: false});


    jQuery('.unsubscribe_form  .email .watermark').watermark('Email@ndm.pays', {useNative: false});

    jQuery('.commande_form  .firstname .watermark').watermark('Firstname', {useNative: false});
    jQuery('.commande_form  .lastname .watermark').watermark('Name', {useNative: false});
    jQuery('.commande_form  .email .watermark').watermark('Email', {useNative: false});
    jQuery('.commande_form  .mobile .watermark').watermark('Mobile number (optional)', {useNative: false});
    jQuery('.commande_form  .address .watermark').watermark('Address1', {useNative: false});
    jQuery('.commande_form  .floor .watermark').watermark('Address2', {useNative: false});
    jQuery('.commande_form  .apartment .watermark').watermark('Address3', {useNative: false});
    jQuery('.commande_form  .zipmain .zip .watermark').watermark('Zip code', {useNative: false});
    jQuery('.commande_form  .zipmain .city .watermark').watermark('Town / City', {useNative: false});


    jQuery('.readingform .SideForm input[type="email"]').watermark('Email', {useNative: false});
    jQuery('.readingform .lastname .watermark').watermark('Name', {useNative: false});
    jQuery('.readingform .email .watermark').watermark('Email', {useNative: false});

    jQuery('.contactform .firstname .watermark').watermark('Firstname', {useNative: false});
    jQuery('.contactform .lastname .watermark').watermark('Name', {useNative: false});
    jQuery('.contactform .email .watermark').watermark('Email', {useNative: false});
    jQuery('.contactform .text_area textarea').watermark('Your message', {useNative: false});

    jQuery(".parchemin_one p, .prachemin_two.black p").each(function () {
        var $this = jQuery(this);
        if ($this.html().replace(/\s| /g, '').length === 0)
            $this.remove();
    });

});
/* READY END */

jQuery(window).resize(function () {

    /* =============  Functions calling section (start) ============== */
    middleimage();
    commonscripts();
    atachdetach();
    stick_bar();


    /* ============ Functions calling section (End) ============== */


    if (!jQuery('.page.home').length) {
        if (jQuery(window).width() < 769) {
            var win_height = jQuery(window).height();
            var banner_hgt = jQuery('.PageRightBanner').innerHeight();
            var for_hgt = jQuery('#sidebarform').height();
            //var final_hgt=win_height-banner_hgt+10;
            var final_hgt = win_height;
            jQuery('#sidebarform').css('max-height', final_hgt);
        }
        else {
            jQuery('#sidebarform').css('max-height', "");
        }
    }


    if (jQuery(window).width() < 985) {

        jQuery(".HeaderBottom").hide();
        jQuery(".MobileMenuBtn.active").removeClass("active");

    } else if (jQuery(window).width() > 986) {

        jQuery(".HeaderBottom").show();

    }

});


jQuery(document).scroll(function () {
    stick_bar();
});
